__turbopack_context__.v({
  "card": "page-unavailable-module__NTMwPG__card",
  "description": "page-unavailable-module__NTMwPG__description",
  "icon": "page-unavailable-module__NTMwPG__icon",
  "notice": "page-unavailable-module__NTMwPG__notice",
  "noticeIcon": "page-unavailable-module__NTMwPG__noticeIcon",
  "noticeTitle": "page-unavailable-module__NTMwPG__noticeTitle",
  "title": "page-unavailable-module__NTMwPG__title",
});
